export default [
  {
    path: '/app/social-media',
    name: 'SocialMedia',
    component: () => import('@/views/SocialMedia/Index.vue'),
    meta: {
      pageTitle: 'Sosyal Medya',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'SOCIAL_MEDIA_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/social-media/add',
    name: 'SocialMediaAdd',
    component: () => import('@/views/SocialMedia/Add.vue'),
    meta: {
      pageTitle: 'Sosyal Medya',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/social-media',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'SOCIAL_MEDIA_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/social-media/edit/:id',
    name: 'SocialMediaEdit',
    component: () => import('@/views/SocialMedia/Edit.vue'),
    meta: {
      pageTitle: 'Sosyal Medya',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/social-media',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'SOCIAL_MEDIA_EDIT',
      action: 'read',
    },
  },
]
